import React from "react";
import { useTranslation } from "react-i18next";

export const LegalDocumentsTableHead: React.FC = () => {
  const { t } = useTranslation();

  return (
    <thead>
      <tr className="font-light text-[16px] h-11 leading-[100%] text-gray-550 border-b border-gray-200">
        <td className="py-3 px-6 w-[520px]">{t("File name")}</td>
        <td className="py-3 px-6 w-[120px]">{t("File size")}</td>
        <td className="py-3 px-6 w-[176px]"></td>
      </tr>
    </thead>
  );
};
